const isLocal = window.location.hostname === "localhost";

const API_BASE = isLocal
  ? "http://localhost/jyotish_karmaa/api" // local
  : "https://visnology.com/api";          // live, always HTTPS

export async function apiFetch(path, options = {}) {
  try {
    const url = `${API_BASE}/${path}`;
    const headers = {...(options.headers || {})};

    if (!headers["Content-Type"]) headers["Content-Type"] = "application/json";

    if (!options.skipAuth) {
      const token = localStorage.getItem("jy_token");
      if (token) headers["Authorization"] = `Bearer ${token}`;
    }

    const res = await fetch(url, { ...options, headers });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`HTTP ${res.status}: ${text}`);
    }

    const data = await res.json();
    return data;
  } catch (err) {
    console.error("API Fetch Error:", err);
    return { success: false, message: err.message };
  }
}
